module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "free-container"
  }, [_c('div', {
    staticClass: "free-rooms total"
  }, [_vm._v("\n\t\tTotal: " + _vm._s(_vm.total) + "\n\t")]), _vm._v(" "), _vm._l((_vm.model.ratesPerDates), function(day, indexDay) {
    return _c('div', {
      key: indexDay,
      staticClass: "free-rooms"
    }, _vm._l((day.roomTypes), function(room, indexRoom) {
      return _c('div', {
        key: indexRoom,
        staticClass: "free-rooms-type"
      }, [_c('span', [_vm._v(_vm._s(room.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(room.total))])])
    }))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577fb4ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/FreeRoomsDay.vue
// module id = 1644
// module chunks = 20